export { default as ErrorSection } from "./ErrorSection/ErrorSection";
